import React, { useEffect, useState } from 'react';


const AnalyticsFilters = ({ filters, setFilters }) => {
  const formatDate = (date) => date.toISOString().split('T')[0];

  /* --------------------------------------------------
     Draft (UI) state — user edits here
  -------------------------------------------------- */
  const [draftFilters, setDraftFilters] = useState(filters);

  /* --------------------------------------------------
     Keep draft in sync if filters change externally
  -------------------------------------------------- */
  useEffect(() => {
    setDraftFilters(filters);
  }, [filters]);

  /* --------------------------------------------------
     Apply button handler
  -------------------------------------------------- */
  const applyFilters = () => {
    if (!draftFilters.from || !draftFilters.to) return;
    setFilters(draftFilters);
  };

  /* --------------------------------------------------
     Presets (apply immediately)
  -------------------------------------------------- */
  const setPreset = (type) => {
    const now = new Date();
    let from, to;

    switch (type) {
      case 'today':
        from = to = formatDate(now);
        break;

      case 'week': {
        const start = new Date(now);
        start.setDate(now.getDate() - 6);
        from = formatDate(start);
        to = formatDate(now);
        break;
      }

      case 'month': {
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        from = formatDate(start);
        to = formatDate(now);
        break;
      }

      case 'year': {
        const start = new Date(now.getFullYear(), 0, 1);
        from = formatDate(start);
        to = formatDate(now);
        break;
      }

      default:
        return;
    }

    const next = { range: type, from, to };
    setDraftFilters(next);
    setFilters(next); // ✅ presets apply instantly
  };

  const hasChanges =
    draftFilters.from !== filters.from ||
    draftFilters.to !== filters.to;

  

  return (
  <div className="filters bg-white shadow-md rounded-xl p-4 mb-6">
    <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">

      {/* Left */}
      <div className="flex items-center gap-2">
        <div className="w-1 h-8 bg-gradient-to-b from-cyan-500 to-blue-500 rounded-full" />
        <h3 className="text-lg font-semibold text-slate-700">
          Date Range
        </h3>
      </div>

      {/* Right */}
      <div className="flex flex-col lg:flex-row gap-4 w-full lg:w-auto">

        {/* Presets */}
        <div className="flex flex-wrap gap-2 bg-slate-50 p-1 rounded-lg w-full lg:w-auto">
          {['today', 'week', 'month', 'year'].map((value) => (
            <button
              key={value}
              onClick={() => setPreset(value)}
              className={`flex-1 sm:flex-none px-4 py-2 rounded-lg font-medium text-sm transition-all ${
                filters.range === value
                  ? 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white shadow-md'
                  : 'text-slate-600 hover:bg-white'
              }`}
            >
              {value.charAt(0).toUpperCase() + value.slice(1)}
            </button>
          ))}
        </div>

        {/* Custom range */}
        <div className="flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center gap-2 w-full lg:w-auto">

          <input
            type="date"
            value={draftFilters.from || ''}
            onChange={(e) =>
              setDraftFilters({
                ...draftFilters,
                from: e.target.value,
                range: undefined
              })
            }
            className="border rounded-lg px-4 py-2 w-full sm:w-auto"
          />

          <span className="hidden sm:inline">→</span>

          <input
            type="date"
            value={draftFilters.to || ''}
            onChange={(e) =>
              setDraftFilters({
                ...draftFilters,
                to: e.target.value,
                range: undefined
              })
            }
            className="border rounded-lg px-4 py-2 w-full sm:w-auto"
          />

          {/* Apply */}
          <button
            onClick={applyFilters}
            disabled={!draftFilters.from || !draftFilters.to || !hasChanges}
            className="px-4 py-2 rounded-lg font-medium text-sm
                       bg-gradient-to-r from-cyan-500 to-blue-500
                       text-white shadow-md transition-all
                       w-full sm:w-auto
                       disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Apply
          </button>

        </div>
      </div>
    </div>
  </div>
);

};

export default AnalyticsFilters;
